export enum NavBarItem {
    SourceCompetition = 'eredivisie',
    Competition = 'competitie',
    Cup = 'beker',
    SuperCup = 'supercup',
    
    Schedule = 'programma', 

    ContextMenu = 'menu',

    Achievements = 'prijzen',

    Rules = 'spelregels',

    Admin = 'beheer',
    Invite = 'uitnodigen', 
    
    Scouting = 'scounting',
    PoolUsers = 'deelnemers',
    MyTeam = 'mijn team',
    Transfers = 'transfers',
}